import PropTypes from 'prop-types'
import React, { lazy, Suspense } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { getCurrentContextuserIdDetails, getListOfOrganizations } from './api/components-examples/Admin/AccountUtility'
import './api/components-examples/Admin/admin.css'
import BillingPopUp from './api/components-examples/Admin/BilliingPopUp'
import ProjectAccessRemoveAlert from './api/components-examples/Admin/ProjectAccessRemoveAlert'
import AlertBox from './api/components-examples/AlertComponent'
import { mobileRoutes } from './api/components-examples/Routes/routes'
import UberContainer from './api/components-examples/UberService/UberContainer'
import {
  allowedFeatures,
  getCSubscripedPlanName,
  getOrgChoices,
  getParsedObject,
  manageOrgChoice,
  sUserCredentials,
  updateUserCredientals
} from './api/components-examples/utils/commonUtilityFunctions'
import MainErrorBoundaryParent from './api/components-examples/utils/ErrorBoundary/MainErrorBoundaryParent'
import Welcome from './api/components-examples/Welcome'
import './api/components-examples/Welcome/index.css'
import UserWelcome from './api/components-examples/Welcome/UserWelcome'
import { addTaskWindowTroughtApi, setProjectAccessRemoved } from './api/redux/FrameWorkReducer'
import { addNotification, showNotification } from './api/redux/notificationAction'
import { setUserProfileID } from './api/redux/UserProfile'
import { setTheme } from './api/redux/UserTheme'
import MessageBox from './api/ResponsiveMessage'
import './dashboard-style.css'
import './Dashboard.css'
import './dt-icons.css'
import './emlyDashboard.css'
import './emlyMobile.css'
import './table.css'
import './index.css'
import { MainContent } from './MainContent'
import MainDashboardWrapper from './MainDashboardWrapper'
import MainError from './MainDashboardWrapper/MainErrorComponent'
import { PublicRoutes } from './PublicRoutes'
import SSE from './SSE'
import './styles.css'
import RestoreUber from './UI-components/Uber/RestoreUber'
import { jwtDecode } from 'jwt-decode';
import BillingExpireContactNonOwner from './UI-components/Templates/BillingExpireContactNonOwner'
import BillingExpireContactOwner from './UI-components/Templates/BillingExpireContactOwner'
import SessionIdle from './UI-components/SessionHandling/SessionIdle'
import SessionIdleConfirmation from './UI-components/SessionHandling/SessionIdleConfirmation'
import Survey from './UI-components/WelcomeSurvey/Survey'
import PopUP from './api/components-examples/PopUP'
import WaitingLoaders from './UI-components/Loaders/WaitingLoaders'
import { ensureDataLoaded } from './api/masterDataFetcher'
import ProjectNotFoundPopup from './UI-components/ProjectNotFoundPopup/ProjectNotFoundPopup'

const UserInfo = React.createContext()

const SignInRequired = lazy(() => import('../src/KeyCloak/SignInRequired'))
const NoSignInRequired = lazy(() => import('../src/KeyCloak/NoSignInRequired'))

class Dashboard extends React.Component {
  constructor() {
    super()
    this.state = {
      activeItem: null,
      errorMessage: null,
      defaultPath: null,
      navCollapse: false,
      appStatusCollapse: true,
      loadError: null,
      loaderImage: null,
      loading: false,
      userLoading: false,
      isMobile: false,
      billing: false,
      billingAddress: null,
      buyPlan: false,
      upgradeplanloading: false,
      retryCount: 0,
      welcomScreen: false,
      currentOrganization: [],
      intializeUberLoader: false,
      userNotFound: false,
      showUberRestore: false,
      sessionIdleScreen: false,
      projectNotFound: false,
      projectNotFoundLoading: false
    }
    this._lastLoadedOrgId = null
  }

  handleResize = () => {
    const current_logged_user = getCurrentContextuserIdDetails(
      this.props.myUserAccountInfo && this.props.myUserAccountInfo.current_logged_user
    )
    const matches = mobileRoutes(current_logged_user).some(item => this.props.location.pathname.startsWith(item));
    if (matches) {
      this.setState({
        isMobile: window.innerWidth <= 768
      })
    } else {
      this.setState({
        isMobile: false
      })
    }

    if (window.innerWidth <= 768) {
      this.props.dispatch({
        type: 'GET_HELPER_KEYS_SUCCESS',
        payload: { isMobile: true },
      });
    } else {
      this.props.dispatch({
        type: 'GET_HELPER_KEYS_SUCCESS',
        payload: { isMobile: false },
      });
    }
  }

  navigateTo = path => {
    const { history } = this.props
    history.push(path)
  }

  setRealHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--real-vh', `${vh}px`);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('resize', this.setRealHeight);
    window.addEventListener('orientationchange', this.setRealHeight);
    this.setRealHeight();

    this.handleResize()
    this.fetchMyAccountInfo()
    this.fetchDatoinServices()
    this.fetchHelpLinks()
    this.windowFocusEventCapture()
  }

  fetchUserRoles = () => {
    const api = this.props.api
    const current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
    if (api == null) return

    // Guard: already loading or already fetched for this specific context
    const currentContextId = `${current_logged_user.orgId}_${current_logged_user.spaceId}`;
    const { getAvailableUserRoles } = this.props;
    if (getAvailableUserRoles && (getAvailableUserRoles.isLoading || (getAvailableUserRoles.fetched && getAvailableUserRoles.lastContextId === currentContextId))) {
      return Promise.resolve();
    }

    const action = api.getCurrentRolesOfUsersRSAA(current_logged_user)
    return this.props.dispatch(action)
  }

  checkAllowedSize = () => {
    const api = this.props.api
    let current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
    if (api === null) return
    if (current_logged_user.spaceId !== undefined || current_logged_user.spaceId !== null)
      this.props.dispatch(api.createDatasetUploadMaxSizeRSAA(current_logged_user))
  }

  upgradePlan = planId => {
    this.setState({ upgradeplanloading: true })
    let current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)

    const bodyparams = {
      successUrl: `${window.REACT_APP_SELF_URL}/organizations/billings?paymentSuccess=78dfr030`,
      cancelUrl: `${window.REACT_APP_SELF_URL}/organizations/billings?paymentFail=s67830-09`,
      productId: planId.value,
      paymentMode: `subscription`
    }

    const { api } = this.props
    if (api == null) return
    Promise.resolve(this.props.dispatch(api.createCheckOutSessionRSAA(current_logged_user, bodyparams))).then(
      response => {
        const t = response.type.toLowerCase()
        const hasError = t.endsWith('failure')
        if (!hasError) {
          window.location = response.payload.stripe && response.payload.stripe.url ? response.payload.stripe.url : '/'
          this.setState({ upgradeplanloading: false })
        } else {
          this.props.dispatch(
            addNotification(
              `${response.payload && response.payload.response && response.payload.response.message
                ? response.payload.response.message
                : window.REACT_APP_ERROR_MESSAGE
              }`,
              'danger',
              false
            )
          )
          this.props.dispatch(showNotification(true))
          this.setState({ upgradeplanloading: false })
        }
      }
    )
  }

  updatePlan = () => {
    let current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
    fetch(`${window.REACT_APP_GATEWAY_API_URL}/v3/org/${current_logged_user.orgId}/update_plan`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${this.props.api.keycloakToken()}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ returnUrl: `${window.REACT_APP_SELF_URL}/billings` })
    })
      .then(r => r.json().then(data => ({ status: r.status, payload: data })))
      .then(response => {
        if (response.status === 200) {
          this.setState({ billingAddress: response.payload.stripe.url, billing: true })
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  fetchUberDeployment = silent => {
    let current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
    const api = this.props.api

    if (api === null) return
    if (typeof current_logged_user !== 'object' || current_logged_user === null) return

    const action = api.createFetchUberDeploymentRSAA(current_logged_user.orgId, silent, current_logged_user.spaceId)
    Promise.resolve(this.props.dispatch(action)).then(result => {
      if (result.type.endsWith('SUCCESS')) {
        if (result.payload.status === 'DEPLOY_SUCCESS' && silent === undefined) {
          this.checkAllowedSize(current_logged_user)
        }
      }
    })
  }

  getPath = () => {
    return this.props.location.pathname
  }

  fetchDatoinServices() {
    const api = this.props.api
    if (api == null) return
    const action = api.createFetchDatoinservicesRSAA()
    this.props.dispatch(action)
  }

  fetchMyProfile(orgId, spaceId) {
    this.fetchBuildInfo(orgId)
    this.setState({ loading: true })
    this.setState({ loaderImage: 'profile' })
    const api = this.props.api
    if (api == null) return
    const action = api.createFetchMyProfileRSAA(orgId, spaceId)
    Promise.resolve(this.props.dispatch(action)).then(response => {
      const hasError = response.type.toLowerCase().endsWith('failure')

      if (hasError && spaceId !== 'undefined') {
        if (
          response.payload.status === 404 &&
          response.payload.response.message !== undefined &&
          response.payload.response.message.startsWith('No role found for user having user')
        ) {
          this.props.dispatch(setProjectAccessRemoved(true))
          this.setState({ projectAccessRemoved: true, loading: false })
        } else {
          this.props.dispatch(setProjectAccessRemoved(false))
          this.setState({ loadError: true, loading: false })
        }
      } else {
        this.props.dispatch(setProjectAccessRemoved(false))
        this.setState({ loading: false, loaderImage: null })
        this.fetchPermissionMatrix()
        this.fetchUberDeployment()
        this.tasks()
      }
    })
  }

  fetchBuildInfo = () => {
    const current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
    const api = this.props.api
    if (api == null) return
    const action = api.createFetchVersionInfoRSAA(current_logged_user.orgId)
    this.props.dispatch(action)
  }

  fetchOrgConfigiuration = () => {
    const current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
    const api = this.props.api
    const action = api.getAllDefaultConfigRulesOfOrgRSAA(current_logged_user)
    this.props.dispatch(action)
  }

  tasks = () => {
    let current_conf = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)

    const action = this.props.api.createTasksRSAA(current_conf)
    Promise.resolve(this.props.dispatch(action)).then(response => {
      const hasError = response.type.toLowerCase().endsWith('failure')
      if (!hasError) {
        if (response.payload.notifications !== undefined && response.payload.notifications.length > 0) {
          const data = response.payload.notifications
            .filter(i => i.type === 'JOB')
            .map(i => {
              return {
                ...i,
                time: new Date().getTime()
              }
            })
          this.props.dispatch(addTaskWindowTroughtApi(data))
        }
      }
    })
  }

  intializeUberStore = () => {
    this.setState({ intializeUberLoader: true })
    let current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
    const api = this.props.api
    const action = api.createUberDeploymentRSAA(
      {
        body: JSON.stringify({
          deploymentInfo: {
            services: []
          },
          orgInfo: {
            orgName: this.state.currentOrganization.name
          }
        })
      },
      current_logged_user.orgId,
      {}
    )
    Promise.resolve(this.props.dispatch(action)).then(response => {
      const hasError = response.type.toLowerCase().endsWith('failure')
      if (!hasError) {
        setTimeout(() => {
          this.fetchUberDeployment()
        }, 3000)
      } else {
        this.props.dispatch(
          addNotification(
            response.payload && response.payload.response && response.payload.response.message,
            'error',
            false
          )
        )
        this.props.dispatch(showNotification(true))
      }
      setTimeout(() => {
        this.setState({ intializeUberLoader: false })
        try {
          this.addInLStorage(current_logged_user, 'TRUE')
        } catch (error) {
          console.log('Error setting value in Localstorage', error)
        }
      }, 2500)
    })
  }

  addInLStorage(current_logged_user, value) {
    manageOrgChoice(window.localStorage.OrgChoice, current_logged_user.orgId, 'accountWelcome', value)
  }

  subscriptionCheck() {
    let current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
    const api = this.props.api
    //Don't do anything if api does not exist.
    if (api == null || !current_logged_user) return
    const action = api.getOrgSubscriptionCheckRSAA(current_logged_user)
    Promise.resolve(this.props.dispatch(action)).then(response => {
      const hasError = response.type.toLowerCase().endsWith('failure')
      if (!hasError) {
        const currentOrganization = this.getCurrentOrganiztion(current_logged_user.orgId)
        if (currentOrganization) {
          this.setState({ currentOrganization: currentOrganization })
        }

        if (
          response.payload &&
          response.payload.subscriptionStatus &&
          response.payload.subscriptionStatus === 'PAYMENT_EXPIRED'
        ) {
          this.updatePlan()
        } else if (
          response.payload &&
          response.payload.subscriptionStatus &&
          response.payload.subscriptionStatus === 'BUY_PLAN'
        ) {
          this.setState({ buyPlan: true })
        } else if (
          response.payload &&
          response.payload.subscriptionStatus &&
          response.payload.subscriptionStatus === 'OK'
        ) {
          if (currentOrganization && currentOrganization.spaces && currentOrganization.spaces.length === 0) {
            this.setState({ welcomScreen: true })
          }
        }
      } else {
        if (this.state.retryCount < 3) {
          this.setState({ retryCount: this.state.retryCount + 1 })
          setTimeout(() => {
            this.subscriptionCheck()
          }, [1500])
        } else {
          console.error('Max retry attempts reached')
        }
      }
    })
  }

  subscriptionUsage() {
    let current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
    const api = this.props.api
    //Don't do anything if api does not exist.
    if (api == null) return
    const action = api.createFetchMySubscriptionPlanUsageRSAA(current_logged_user)
    this.props.dispatch(action)
  }

  fetchMyAccountInfo() {
    this.setState({ userLoading: true })
    const api = this.props.api
    if (api == null) return
    const action = api.createFetchUserAccountInfo()
    Promise.resolve(this.props.dispatch(action)).then(response => {
      if (response.payload.current_logged_user !== undefined) {
        this.props.dispatch(setUserProfileID(response.payload.current_logged_user))
      } else {
        this.props.dispatch(setUserProfileID('error'))
      }
      this.setState({ userLoading: false })
      const hasError = response.type.toLowerCase().endsWith('failure')
      if (!hasError) {
        if (response.payload.rolesUser) {
          const current_logged_user = getCurrentContextuserIdDetails(response.payload.current_logged_user)
          if (current_logged_user !== 'NOCACHE' && current_logged_user !== 'NEWUSER') {
            this.setCurrentContext(current_logged_user)
            this.fetchMyProfile(current_logged_user.orgId, current_logged_user.spaceId)
          } else {
            const orgs = response.payload.rolesUser.organizations
            if (!orgs || orgs.length === 0) {
              console.warn('[Dashboard] No organizations found for new user, skipping context setup')
              this.setState({ userLoading: false })
              return
            }
            const userResponse = orgs[0]
            const switchTo = {
              orgId: userResponse.id,
              orgIdName: userResponse.title,
              spaceId: userResponse.spaces[0] && userResponse.spaces[0].id ? userResponse.spaces[0].id : 'undefined',
              spaceIdName:
                userResponse.spaces[0] && userResponse.spaces[0].name ? userResponse.spaces[0].name : 'No Project Yet'
            }
            sUserCredentials(
              window.localStorage.defaultProfileSetting,
              response.payload.current_logged_user,
              switchTo,
              true
            )
            const currentContextLoggedUser = getCurrentContextuserIdDetails(response.payload.current_logged_user)
            this.setCurrentContext(currentContextLoggedUser)
            this.fetchMyProfile(currentContextLoggedUser.orgId, currentContextLoggedUser.spaceId)
          }
        }
        const currentContextLoggedUser = getCurrentContextuserIdDetails(response.payload.current_logged_user)
        ensureDataLoaded(this.props.dispatch, this.props.api, currentContextLoggedUser, this.props)
        this.fetchUserRoles()
        this.subscriptionUsage()
        this.subscriptionCheck()
        this.fetchOrgConfigiuration()
      } else {
        if (response && response.payload && response.payload.status && response.payload.status === 404) {
          this.setState({ userNotFound: true, userLoading: false })
        } else {
          this.setState({ loadError: true, userLoading: false })
        }
      }
    })
  }

  fetchHelpLinks() {
    const api = this.props.api
    //Don't do anything if api does not exist.
    if (api == null) return
    const action = api.createFetchHelpLinksRSAA()
    this.props.dispatch(action)
  }

  fetchPermissionMatrix() {
    let current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
    const api = this.props.api
    if (api == null) return
    const action = api.fetchPermissionMatrixObjectRSAA(current_logged_user)
    this.props.dispatch(action)
  }

  setCurrentContext = value => {
    this.setState({ loaderImage: 'usrContext' })
    const api = this.props.api
    if (api == null) return
    const action = api.getCurrenttContextRSAA(value)
    this.props.dispatch(action)
  }

  fetchTheme() {
    let local = this.props.theme

    const theme = window.localStorage.getItem('localTheme')
    this.props.dispatch(setTheme(theme === null ? 'light' : theme))
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.api !== prevProps.api) {
      this.fetchDatoinServices()
      // this.fetchGroupMaster() // Removed redundant direct call, fetchAllFlowsAndGroups handles it
      this.fetchHelpLinks()
      this.fetchMyAccountInfo()
      this.fetchTheme()
    }

    if (
      this.props &&
      this.props.location &&
      this.props.location.pathname &&
      this.props.location.pathname !== prevProps.location.pathname
    ) {
      this.handleResize()
    }

    if (prevProps.myProfile !== this.props.myProfile && !this.props.myProfile.isLoading) {
      const current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
      let thisPath = `/${current_logged_user.orgId}/${current_logged_user.spaceId}/projects/${current_logged_user.spaceId}`
      if (current_logged_user.spaceId === 'undefined') {
        thisPath = `/projects`
      }
      this.setState({
        defaultPath: thisPath
      })

      if (prevProps.myProfile.roles !== this.props.myProfile.roles) {
        this.fetchPermissionMatrix()
      }
    }

    if (
      this.props.checkUberDeployment !== prevProps.checkUberDeployment &&
      this.props.checkUberDeployment.status === 'DEPLOY_SUCCESS'
    ) {
      const isNewUser =
        this.props.myUserAccountInfo.current_logged_user !== undefined &&
          this.props.myUserAccountInfo.rolesUser === undefined
          ? true
          : this.props.myUserAccountInfo.rolesUser !== undefined &&
            this.props.myUserAccountInfo.rolesUser.organizations[0].spaces.length === 0
            ? true
            : false
      const currentUrl = window.location.href
      const samepageOrgPage = currentUrl.search('projects') === -1
      if (isNewUser && samepageOrgPage) {
        console.warn('[Dashboard] Redirecting new user to /projects from componentDidUpdate')
        window.location = '/projects'
      }
    }

    if (
      this.props.uberIsDown &&
      !this.props.uberIsDown.isLoading &&
      this.props.uberIsDown.status === 'SHOWUBERISDOWN' &&
      this.props.uberIsDown !== prevProps.uberIsDown
    ) {
      this.setState({ showUberRestore: true })
    }

    if (
      this.props.uberIsDown &&
      !this.props.uberIsDown.isLoading &&
      this.props.uberIsDown.status === 'HIDEUBERISDOWN' &&
      this.props.uberIsDown !== prevProps.uberIsDown
    ) {
      this.setState({ showUberRestore: false })
    }

    if (
      this.props.rolesRevoked &&
      !this.props.rolesRevoked.isLoading &&
      this.props.rolesRevoked.status === 'ROLE_DOWNGRADED' &&
      this.props.rolesRevoked !== prevProps.rolesRevoked
    ) {
      const current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
      this.refetchMyAccountInfo(current_logged_user)
      this.fetchPermissionMatrix()
    }

    if (
      this.props.isBillingExpire &&
      !this.props.isBillingExpire.isLoading &&
      this.props.isBillingExpire.isPlan === 'INVALID_SUBSCRIPTION' &&
      this.props.isBillingExpire.isPlan !== prevProps.isBillingExpire.isPlan
    ) {
      this.subscriptionCheck()
    }

    /* Handling 401 Unauthorized - Session Expired */
    if (
      this.props.sessionExpired &&
      this.props.sessionExpired.sessionExpired === true &&
      prevProps.sessionExpired.sessionExpired !== true
    ) {
      this.sessionExpire()
      this.props.dispatch({ type: 'RESET_SESSION_EXPIRED' })
    }

    /* Handling 404 Project Not Found */
    if (
      this.props.projectNotFound &&
      this.props.projectNotFound.showPopup === true &&
      prevProps.projectNotFound.showPopup !== true
    ) {
      this.handleProjectNotFound()
      this.props.dispatch({ type: 'RESET_PROJECT_NOT_FOUND' })
    }

    if (
      this.props.myUserAccountInfo &&
      this.props.myUserAccountInfo.current_logged_user &&
      this.props.isSubscriptionCheck &&
      !this.props.isSubscriptionCheck.isLoading &&
      this.state.currentOrganization !== prevState.currentOrganization &&
      this.props.myProfile &&
      !this.props.myProfile.isLoading &&
      this.props.myProfile.orgMaturity &&
      this.props.checkUberDeployment &&
      getCSubscripedPlanName(this.props.isSubscriptionCheck) !== 'LEARNER'
    ) {
      const automaticUberUp = localStorage.getItem('AUTOMATIC_UBER_UP')
      if (automaticUberUp && this.props.myProfile.orgMaturity === "LOW") {
        if (this.props.checkUberDeployment.status !== 'DEPLOY_SUCCESS') {
          this.intializeUberStore()
        }
        localStorage.removeItem('AUTOMATIC_UBER_UP')
      }
    }
  }

  updateLocalCache = () => {
    const currentProfileSetting = getParsedObject(window.localStorage.defaultProfileSetting)
    const userId = this.props.myUserAccountInfo.current_logged_user
    if (currentProfileSetting && currentProfileSetting[userId]) {
      const activeOrgKey = currentProfileSetting[userId].activeOrganization
      const orgData = currentProfileSetting[userId][activeOrgKey]
      if (orgData && orgData.spaceId === 'undefined') {
        // Already cleared — don't reload to avoid infinite loop
        return
      }
    }
    Promise.resolve(updateUserCredientals(userId)).then(() => { console.warn('[Dashboard] updateLocalCache redirecting to /'); window.location = '/' })
  }

  refetchMyAccountInfo = (current_logged_user) => {

    Promise.resolve(getListOfOrganizations(this.props.api.keycloakToken()))
      .then(response => {
        if (response.message && response.message.startsWith('No organizations found for user having')) {
          this.updateLocalCache()
        } else if (response.rolesUser && response.rolesUser.organizations) {
          response.rolesUser.organizations.map(it => {
            if (it.id == current_logged_user.orgId) {
              if (it.spaces) {
                const spaceIdFound = it.spaces.some(space => space.id === current_logged_user.spaceId);
                if (it.spaces.length === 0 || spaceIdFound === false) {
                  this.updateLocalCache()
                }
              }
            }
          })
        }
      }
      )
  }

  getCurrentOrganiztion = orgId => {
    if (
      this.props.myUserAccountInfo &&
      this.props.myUserAccountInfo.rolesUser &&
      this.props.myUserAccountInfo.rolesUser.organizations
    ) {
      const currentOrganization = this.props.myUserAccountInfo.rolesUser.organizations.reduce((acc, next) => {
        if (next.id === orgId) {
          return next
        } else {
          return acc
        }
      }, [])
      return currentOrganization
    } else {
      return null
    }
  }

  getUserDefaultOrganization = () => {
    const accountInfo = this.props.myUserAccountInfo;

    // Make sure the nested objects/arrays exist
    if (
      accountInfo &&
      accountInfo.rolesUser &&
      Array.isArray(accountInfo.rolesUser.organizations)
    ) {
      // Find the organization whose id matches AND has defaultOrg === true
      const current_logged_user = getCurrentContextuserIdDetails(accountInfo.current_logged_user)

      const currentOrganization = accountInfo.rolesUser.organizations.find(
        function (org) {
          return org.id === current_logged_user.orgId && org.defaultOrg === true;
        }
      );

      // Return the object if found, otherwise null
      return currentOrganization || null;
    }

    // Fallback when data is missing
    return null;
  };

  getCurrentSpace = (spaces, spaceId) => {
    const currentSpace = spaces.reduce((acc, next) => {
      if (next.id === spaceId) {
        return next.advancedMode !== undefined ? next.advancedMode : false
      } else {
        return acc
      }
    }, [])
    return currentSpace
  }

  onNavCollapse = () => {
    this.setState({ navCollapse: !this.state.navCollapse })
  }

  collapseNav = () => {
    this.setState({ navCollapse: true })
  }

  openNav = () => {
    this.setState({ navCollapse: false })
  }

  onAppStatusCollapse = () => {
    this.setState({ appStatusCollapse: !this.state.appStatusCollapse })
  }

  collapseAppStatus = () => {
    this.setState({ appStatusCollapse: false })
  }

  openAppStatus = () => {
    this.setState({ appStatusCollapse: true })
  }

  checkConfigurationChange = () => {
    if (this.props.myProfile) {
      let current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
      if (typeof current_logged_user === 'object') {
        // Skip redirect if orgId is not set (no-org accounts)
        if (!current_logged_user.orgId || current_logged_user.orgId === 'undefined') return
        if (
          (this.props.currentContext && this.props.currentContext.orgId !== current_logged_user.orgId) ||
          this.props.currentContext.spaceId !== current_logged_user.spaceId
        ) {
          console.warn('[Dashboard] checkConfigurationChange redirecting to /')
          window.location = '/'
        }
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  windowFocusEventCapture = () => {
    let that = this
    try {
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden && that.props.myUserAccountInfo.current_logged_user !== undefined) {
          that.checkConfigurationChange()
          that.fetchUberDeployment(true)
        }
      })
    } catch (error) { }
  }

  getAllowedFeatures = () => {
    const current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
    const currentOrganization = this.getCurrentOrganiztion(current_logged_user.orgId)
    if (currentOrganization && currentOrganization.spaces && currentOrganization.spaces.length === 0) {
      return []
    } else if (currentOrganization && currentOrganization.spaces && currentOrganization.spaces.length > 0) {
      const isAdvanced = this.getCurrentSpace(currentOrganization.spaces, current_logged_user.spaceId)
      return allowedFeatures(isAdvanced)
    } else {
      return []
    }
  }

  getActivateStatus() {
    const current_logged_user = getCurrentContextuserIdDetails(this.props.myUserAccountInfo.current_logged_user)
    const currentValue = getOrgChoices(current_logged_user.orgId, 'accountWelcome')
    const accountWelcome = currentValue !== undefined && currentValue !== null ? currentValue : null
    return accountWelcome
  }

  sessionExpire = () => {
    this.setState({ sessionIdleScreen: true })
  }

  handleProjectNotFound = () => {
    this.setState({ projectNotFound: true })
  }

  handleProjectNotFoundContinue = () => {
    this.setState({ projectNotFoundLoading: true })
    const api = this.props.api
    if (api == null) {
      this.setState({ projectNotFoundLoading: false })
      return
    }

    Promise.resolve(getListOfOrganizations(api.keycloakToken()))
      .then(response => {
        if (response && response.rolesUser && response.rolesUser.organizations) {
          const userResponse = response.rolesUser.organizations[0]

          if (userResponse && userResponse.spaces && userResponse.spaces.length > 0) {
            // Switch to first space
            const switchTo = {
              orgId: userResponse.id,
              orgIdName: userResponse.title,
              spaceId: userResponse.spaces[0].id,
              spaceIdName: userResponse.spaces[0].name
            }
            sUserCredentials(
              window.localStorage.defaultProfileSetting,
              response.current_logged_user,
              switchTo,
              true
            )
            const currentContextLoggedUser = getCurrentContextuserIdDetails(response.current_logged_user)
            this.setCurrentContext(currentContextLoggedUser)
            this.fetchMyProfile(currentContextLoggedUser.orgId, currentContextLoggedUser.spaceId)
          } else {
            // No spaces, update credentials
            const switchTo = {
              orgId: userResponse.id,
              orgIdName: userResponse.title,
              spaceId: 'undefined',
              spaceIdName: 'No Project Yet'
            }
            sUserCredentials(
              window.localStorage.defaultProfileSetting,
              response.current_logged_user,
              switchTo,
              true
            )
            const currentContextLoggedUser = getCurrentContextuserIdDetails(response.current_logged_user)
            this.setCurrentContext(currentContextLoggedUser)
            this.props.history.push('/projects')
          }
        }
        this.setState({ projectNotFoundLoading: false, projectNotFound: false })
      })
      .catch(err => {
        console.error('Error fetching organizations:', err)
        this.setState({ projectNotFoundLoading: false })
        this.props.dispatch(
          addNotification('Failed to switch to default project. Please try again.', 'danger', false)
        )
        this.props.dispatch(showNotification(true))
      })
  }

  getSubscriptionPlanName = () => {
    const currentAvailedPlan =
      this.props.isSubscriptionCheck &&
        !this.props.isSubscriptionCheck.isLoading &&
        this.props.isSubscriptionCheck.subscribedProduct &&
        this.props.isSubscriptionCheck.subscribedProduct.name
        ? this.props.isSubscriptionCheck.subscribedProduct.name
        : 'NO_PLAN'

    return currentAvailedPlan.toUpperCase()
  }


  render() {
    const { myUserAccountInfo } = this.props

    const isNewUser =
      myUserAccountInfo.current_logged_user !== undefined && myUserAccountInfo.rolesUser === undefined ? true : false

    let jwt_token_object = {}

    const currentOrgPlan = this.getSubscriptionPlanName() === "LEARNER" ? "LEARNER" : "NONLEARNER"

    if (this.props.api && this.props.api.keycloakToken()) {
      try {
        const decoded = jwtDecode(this.props.api.keycloakToken())
        jwt_token_object = decoded
      } catch (error) { console.error('Error while decoding the jwt token at dashboard.js', error) }
    }

    if (isNewUser && jwt_token_object && jwt_token_object.org_name !== undefined) {
      return (
        <MainErrorBoundaryParent>
          <Welcome history={this.props.history} />
        </MainErrorBoundaryParent>
      )
    }

    if (this.state.loadError) {
      return (
        <div className="mainDashboardConatiner">
          <MainDashboardWrapper location={this.props.location} planType={currentOrgPlan}>
            <MainError />
          </MainDashboardWrapper>
        </div>
      )
    }

    const userName =
      this.props.persisted.userInformation !== null && this.props.persisted.userInformation.name !== undefined
        ? this.props.persisted.userInformation.name
        : ''

    return (
      <Suspense fallback={<Loader text={null} />}>
        <NoSignInRequired {...this.props}>
          <PublicRoutes />
        </NoSignInRequired>

        <SignInRequired {...this.props}>
          <div className="mainDashboardConatiner">
            <SessionIdle sessionExpire={this.sessionExpire} idleTimeout={1200000} />
            {this.state.sessionIdleScreen &&
              <SessionIdleConfirmation />
            }

            {this.state.projectNotFound &&
              <PopUP
                className="projectNotFoundPopUp"
                width={'60%'}
                bottomButton={true}
                buttonLabel={'Yes, continue'}
                loadingCancel={true}
                bottomButtonCancel={false}
                onExecution={this.handleProjectNotFoundContinue}
                disabled={this.state.projectNotFoundLoading}
              >
                <ProjectNotFoundPopup
                  currentOrgPlan={currentOrgPlan}
                  isLoading={this.state.projectNotFoundLoading}
                />
              </PopUP>
            }

            {
              this.props.myProfile &&
              this.props.myProfile.isLoading === false &&
              // this.props.myProfile.roles === 'owner' &&
              this.props.myProfile.meta &&
              !(this.props.myProfile.meta.survey) &&
              this.props.isSubscriptionCheck &&
              !this.props.isSubscriptionCheck.isLoading &&
              this.props.isSubscriptionCheck.subscriptionStatus === 'OK' &&
              < PopUP
                className="surveyPopUp"
                width={'100%'}
                bottomButton={false}
                loadingCancel={true}
                bottomButtonCancel={false}
                onExecution={() => ''}
              >
                <Survey planType={currentOrgPlan} />
              </PopUP>
            }
            <MainDashboardWrapper
              items={this.getAllowedFeatures()}
              activeItem={this.state.activeItem}
              history={this.props.history}
              myProfile={this.props.myProfile}
              location={this.props.location}
              changeCurrentTab={this.changeCurrentTab}
              myApps={this.props.myApps}
              myUserAccountInfo={myUserAccountInfo}
              myTemplates={this.props.myTemplates}
              checkUberDeployment={this.props.checkUberDeployment}
              myReccTemplates={this.props.myReccTemplates}
              dispatch={this.props.dispatch}
              api={this.props.api}
              project_access_removed={this.props.project_access_removed}
              error={this.state.theme}
              dataset={this.props.dataset}
              planType={currentOrgPlan}
            >
              <MainErrorBoundaryParent history={this.props.history} error={this.state.loadError}>
                {this.props.persisted.userInformation !== null &&
                  this.props.persisted.userInformation.sub !== undefined && (
                    <SSE
                      id={this.props.persisted.userInformation.sub}
                      api={this.props.api}
                      history={this.props.history}
                    />
                  )}
                <div style={{ display: 'flex', flexDirection: 'column' }} className={'right-body-panel'} >

                  <WaitingLoaders />

                  {this.state.upgradeplanloading && <WaitingLoaders show={true} size={90} position='fixed' />}

                  {this.props.project_access_removed === true && <ProjectAccessRemoveAlert />}

                  {this.getPath() !== '/orgInstance' && <UberContainer key={this.props.checkUberDeployment} />}

                  <AlertBox />
                  {this.state.billing && (
                    <>
                      <UserWelcome
                        onCancel={() => this.setState({ billing: !this.state.billing })}
                        isLoading={this.state.intializeUberLoader}
                        primaryAction={() => {
                          if (this.state.billingAddress) {
                            window.location = this.state.billingAddress
                          } else {
                            this.setState({ buyPlan: true })
                          }
                        }}
                        datatheme={this.props.theme}
                        type="BILLING"
                        title={'Start'}
                        isOwner={
                          this.props.myProfile && this.props.myProfile.roles && this.props.myProfile.roles === 'owner'
                            ? true
                            : false
                        }
                        isFirstTime={
                          this.state.currentOrganization &&
                            this.state.currentOrganization.spaces &&
                            this.state.currentOrganization.spaces.length === 0
                            ? true
                            : false
                        }
                      />
                    </>
                  )}

                  {this.state.showUberRestore && this.state.showUberRestore === true && (
                    <RestoreUber
                      key={this.state.showUberRestore}
                      asPopup={true}
                      showCancel={true}
                      isDashboard={true}
                    />
                  )}

                  {this.state.buyPlan &&
                    <>
                      {
                        this.props.userProjectPermissions &&
                          !this.props.userProjectPermissions.isLoading &&
                          this.props.userProjectPermissions.org_billing === true ?
                          <>
                            {isNewUser ?
                              <BillingPopUp
                                setUpgradePlans={() => this.setState({ buyPlan: false })}
                                upgradePlan={this.upgradePlan}
                              />
                              :
                              <BillingExpireContactOwner
                                setUpgradePlans={() => this.setState({ buyPlan: false })}
                                upgradePlan={this.upgradePlan}
                              />
                            }
                          </>
                          :
                          <BillingExpireContactNonOwner
                            setUpgradePlans={() => this.setState({ buyPlan: false })}
                            upgradePlan={this.upgradePlan}
                          />
                      }
                    </>
                  }

                  {this.state.userLoading === false && this.state.loading === false ? (
                    this.state.isMobile ? (
                      <MessageBox history={this.props.history} />
                    ) : (
                      <MainContent
                        paths={this.getAllowedFeatures()}
                        services={this.props.datoinServices}
                        myUserAccountInfo={myUserAccountInfo}
                        error={this.props.apiError}
                        projectInfoKey={this.props.projectInfoKey}
                        defaultPath={
                          this.props.myUserAccountInfo &&
                            this.props.myUserAccountInfo.message &&
                            this.props.myUserAccountInfo.message.startsWith('No organizations found for user having')
                            ? '/organizations'
                            : this.state.defaultPath
                        }
                        history={this.props.history}
                        collapseNav={this.collapseNav}
                        openNav={this.openNav}
                        collapseAppStatus={this.collapseAppStatus}
                        openAppStatus={this.openAppStatus}
                        currentPath={this.props.location.pathname}
                        myProfile={this.props.myProfile}
                        userNotFound={this.state.userNotFound}
                      />
                    )
                  ) : (
                    <div className="centreLoadingSpinner" style={{ height: 'calc( 100vh - 50px )' }}>
                      <WaitingLoaders
                        show={true}
                        message={`Hey ${userName} We're setting up your workspace. This shouldn't take long 😉`}
                        size={90}
                      />
                    </div>
                  )}
                </div>
              </MainErrorBoundaryParent>
            </MainDashboardWrapper>
          </div>
        </SignInRequired>
      </Suspense >
    )
  }
}

Dashboard.propTypes = {
  api: PropTypes.object,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  api: state.api,
  project_access_removed: state.emlyFrameWork.project_access_removed,
  projectInfoKey: state.emlyFrameWork.projectInfoKey,
  apiError: state.apiError,
  myProfile: state.myProfile,
  myHelpLinks: state.myHelpLinks,
  datoinServices: state.datoinServices,
  bgStatus: state.bgStatus,
  myApps: state.myApps,
  myTemplates: state.myTemplates,
  myReccTemplates: state.myReccTemplates,
  checkUberDeployment: state.checkUberDeployment,
  currentContext: state.currentContext,
  myUserAccountInfo: state.myUserAccountInfo,
  dataset: state.emlycreateFetchMyNewDatasetsRSAAReducer.dataset,
  persisted: state.userProfilePersisted,
  userProjectPermissions: state.userProjectPermissions,
  theme: state.theme,
  uberIsDown: state.uberIsDown,
  rolesRevoked: state.rolesRevoked,
  isBillingExpire: state.isBillingExpire,
  isSubscriptionCheck: state.isSubscriptionCheck,
  sessionExpired: state.sessionExpired,
  projectNotFound: state.projectNotFound,
  learnPracticeFlows: state.learnPracticeFlows,
  buildPracticeFlows: state.buildPracticeFlows,
  masterGroupMapper: state.masterGroupMapper,
  getAvailableUserRoles: state.getAvailableUserRoles
})

export default withRouter(connect(mapStateToProps)(Dashboard))
export { UserInfo }

export const Loader = ({ text }) => {
  return (
    <div className="centreLoadingSpinner" style={{ height: 'calc( 100vh - 50px )' }}>
      <WaitingLoaders show={true} size={90} />
    </div>
  )
}
